// this is an autogenerated file from App/Account/Content/Settings/Content/CommsSettings/Settings/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_CommsSettings_Settings(
  $sending_window: jsonb!
  $flags: jsonb!
  $location_id: uuid!
) {
  insert_comms_settings_one(
    object: {
      sending_window: $sending_window
      flags: $flags
      location_id: $location_id
    }
  ) {
    id
  }
}

`